import React from 'react'
import SelfSummary from './SelfSummary';
import GroupSummary from './GroupSummary';

const Summary = ({ customerInfo, labels }) => {

  return (
    <div className=''>
      {customerInfo && <SelfSummary customerInfo={customerInfo} labels={labels} />}
      {customerInfo && <GroupSummary customerInfo={customerInfo} labels={labels} />}
    </div>

  )
}

export default Summary

